angular.module('gym.components').directive('changeTypeSelector', function() {
  return {
    restrict: 'E',
    template: require('templates/components/calendar/change_type_selector.html.slim'),
    scope: {
      changeType: '@',
      changeVerb: '@',
      event: '='
    }
  };
});
